<div [formGroup]="form">
  @if (activiteDonnee) {
    <div class="row">
      <app-control class="col-12 col-xl-4" codeLabel="membre">
        <div class="input-group flex-nowrap">
          <ng-select
            #select
            [items]="$safeNavigationMigration(membreSearchor?.buffer)"
            [virtualScroll]="true"
            [loading]="$safeNavigationMigration(membreSearchor?.loading)"
            bindLabel="label"
            [typeahead]="$safeNavigationMigration(membreSearchor?.input$)"
            (scroll)="membreSearchor?.onScroll($event)"
            placeholder="Sélectionner un membre"
            formControlName="membre"
            bindLabel="label"
            class="w-75"
            (change)="onMembreChange()"
          >
          </ng-select>
          <button class="btn btn-secondary icon-button" type="button" [routerLink]="['/membre/edit', currentMembreId]">
            <i class="material-icons md-18" title="Voir la fiche du membre">description</i>
          </button>
          <button
            class="btn btn-secondary icon-button"
            type="button"
            [routerLink]="['/activitemembre']"
            [queryParams]="{ membreId: currentMembreId }"
          >
            <i class="material-icons md-18" title="Gérer les activités du membre">swap_horiz</i>
          </button>
        </div>
      </app-control>
      <ng-container *ngTemplateOutlet="association; context: { formGroup: form }"></ng-container>
    </div>
  }
  @if (membreDonne) {
    <div class="row">
      <app-control class="col-12 col-xl-4" codeLabel="activite">
        <div class="input-group flex-nowrap">
          <ng-select
            #select
            [items]="$safeNavigationMigration(activiteSearchor?.buffer)"
            [virtualScroll]="true"
            [loading]="$safeNavigationMigration(activiteSearchor?.loading)"
            bindLabel="label"
            [typeahead]="$safeNavigationMigration(activiteSearchor?.input$)"
            (scroll)="activiteSearchor?.onScroll($event)"
            placeholder="Sélectionner une activité"
            formControlName="activite"
            bindLabel="label"
            class="w-75"
          >
          </ng-select>
          <button class="btn btn-secondary icon-button" type="button" (click)="onClickFicheActivite()">
            <i class="material-icons md-18" title="Voir la fiche de l'activité">description</i>
          </button>
          <button
            class="btn btn-secondary icon-button"
            type="button"
            [routerLink]="['/activitemembre']"
            [queryParams]="{ activiteId: currentActiviteId }"
          >
            <i class="material-icons md-18" title="Gérer les membres de l'activité">swap_horiz</i>
          </button>
        </div>
      </app-control>
      <ng-container *ngTemplateOutlet="association; context: { formGroup: form }"></ng-container>
    </div>
  }
  <div class="row">
    <app-list
      class="col-12 mb-3"
      [readOnly]="readOnly"
      formControlName="profils"
      [newElement]="newProfilDto"
      [eltName]="'profil'"
      [consigne]="consigne"
      [collapsible]="true"
      [collapsibleReplie]="!form.touched"
      [nbEltsMax]="20"
      [resume]="resumeProfil"
      [pushDisabled]="!form.valid"
    >
      <ng-template let-ctrl="ctrl" let-new="new">
        <app-saisie-profil [formControl]="ctrl" [readOnly]="readOnly" [consigne]="consigne" [deplie]="new"></app-saisie-profil>
      </ng-template>
    </app-list>
  </div>
</div>

<ng-template #association let-form="formGroup">
  <ng-container [formGroup]="form">
    <app-control class="col-sm-5 col-lg-2" codeLabel="debutAssociation">
      <app-date-input formControlName="debutAsso"></app-date-input>
    </app-control>
    <app-control class="col-sm-5 col-lg-2" codeLabel="finAssociation">
      <app-date-input formControlName="finAsso" (dateModifiee)="onChangeFinAsso()"></app-date-input>
    </app-control>

    <label class="col-6 col-xl-3 mt-2 d-flex align-items-center">
      <input
        class="ms-lg-2 me-2"
        type="checkbox"
        formControlName="actPrincipale"
        [ngClass]="{ 'checkbox-disabled': !!form.get('actPrincipale').value }"
        (change)="onActPrincipaleChange($event)"
      />
      Activité Principale
    </label>
  </ng-container>
</ng-template>
